import { VideoResult } from "common/video/dto/VideoResult";
import styled from "styled-components";
import VideoSingleNav from "components/common/video/VideoSingleNav";
import { Divider } from "@mui/material";
import NavLinkUndecorated from "components/common/style/link/NavLinkUndecorated";
import { videoLinkSingle } from "common/video/video_link_common";
import { dateFormatGet } from "common/date_common";
import { staticContentPath } from "common/static_content_common";
import VideoPlay from "components/common/video/VideoPlay";

type VideoItemProps = {
  video: VideoResult;
};

const VideoItem = ({ video }: VideoItemProps) => {
  return (
    <Div>
      <Divider />
      <Div>
        <NavLinkUndecorated to={videoLinkSingle(video.id)}>
          <div>{dateFormatGet(video.datum)}</div>
          <div>{video.title} </div>
          {video.fileName && (
            <VideoPlay
              filePath={staticContentPath(video.fileName)}
              autoPlay={false}
              muted={true}
              width={200}
            />
          )}
        </NavLinkUndecorated>
        <VideoSingleNav video={video} />
      </Div>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 2rem;
`;

export default VideoItem;
